import { IconProps } from "./Icons";

export const IconCheck = ({
  width = 18,
  height = 18,
  color = "#0B3E5F",
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1875 5.0625L7.3125 12.9375L3.375 9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
